'use strict';
const scrollBehavior = require('./scrollBehavior');

const $videoElement = $('.product-video-slide');
const $galleryItems = $('.swiper-slide.product-slide');
const $fullscreenCloseButton = $('.product-fullscreen-close-button');
const isMobile = () => window.innerWidth < 992;
const isDesktop = () => !isMobile();
let thumbCarousel;
let mobileCarousel;
let mainCarousel;
let observer;
let observerTargetsClass = '.col-images .product-slide';

/**
 * Open fullscreen images for Desktop
 * @returns {void}
 */
function openFullscreenImage() {
  const $overlayActive = $('.product-fullscreen-images-overlay');
  const $fullscreenImageWrapper = $('.product-fullscreen-images-wrapper');
  const $productWrapper = $('.product-wrapper');
  const $fullscreenImage = $('.product-fullscreen-image');
  
  $('body').on('click', '.swiper:not(.thumbnails) .swiper-slide.product-slide:not(.js-editorial-has-editorial)', function () {
    const imgSource = $(this).find('.js-product-image').attr('data-zoom-img');
    $fullscreenImage.attr('src', imgSource);

    // let selected;
    // for (let i = 0; i < $fullscreenImage.length; ++i) {
    //   imgSourceFullscreen = $fullscreenImage[i].dataset.fullSrc;
    //   if (imgSource && imgSource.indexOf(imgSourceFullscreen) !== -1) {
    //     selected = $fullscreenImage[i];
    //   }
    //   $fullscreenImage[i].setAttribute('src', $fullscreenImage[i].dataset.fullSrc);
    //   $fullscreenImage[i].style.display = 'block';
    // }
    $productWrapper.addClass('fullscreen');
    $overlayActive.addClass('active');
    $('html, body').addClass('product-main-overlay');
    $fullscreenCloseButton.focus();
    
  });
  $('body').on('click', '.swiper.thumbnails .product-slide', function () {
    const imgSource = $(this).find('.js-product-image').attr('data-zoom-img');
    $fullscreenImage.attr('src', imgSource);
  });

  $('body').on('click', '.product-fullscreen-close-button', function () {
    $fullscreenImageWrapper.scrollTop(0);
    $productWrapper.removeClass('fullscreen');
    $overlayActive.removeClass('active');
    $('html, body').removeClass('product-main-overlay');
    $galleryItems.get(0).focus();
  });
  
}

/**
 * Add video as a second slide to slider for Desktop view
 * @param {Swiper} carousel - Carousel
 * @return {void}
 */
function addRemoveSlides(carousel) {
  if (isDesktop()) {
    carousel.addSlide(1, $videoElement.parent().clone());
  } else {
    $('.product-slider-container .product-slide').each(function (i, e) {
      if ($(e).children('.product-video-slide').length > 0) {
        carousel.removeSlide(i);
      }
    });
  }

  carousel.update();
}

/**
 * Open fullscreen video for Mobile devices
 * @returns {void}
 */
function openMobileVideo() {
  const $mobileVideoWrapper = $('.product-video-wrapper');

  $mobileVideoWrapper.on('touchstart click', function (e) {
    if (isDesktop()) return;
    e.stopPropagation();
    e.preventDefault();
    $(this).addClass('active');
    $mobileVideoWrapper.find('.product-fullscreen-close-button').focus();
  });

  $fullscreenCloseButton.on('touchstart click', function (e) {
    if (isDesktop()) return true;
    e.stopPropagation();
    $mobileVideoWrapper.removeClass('active');
    $mobileVideoWrapper.focus();

    // used to stop the other buttons to be
    // triggered in the same time
    return false;
  });
}

/**
 * Trigger click when pressing enter on product slide
 */
// function handleCarouselKeypress() {
//   $('body').on('keypress', '.product-slide', function (event) {
//     if (event.key === 'Enter') {
//       $(event.target).trigger('click');
//     }
//   });
// }

const handleThumbsMarkerVisibility = function(swiper){
  //const maxSlidesPerView = swiper.params.slidesPerView;
  document.querySelector('.thumbs-marker.top').classList.toggle('shown', swiper.progress > 0)
  document.querySelector('.thumbs-marker.bottom').classList.toggle('shown', swiper.progress < 1)
}

let debouncer;
// const syncThumbnailsWithScroll = function(swiper){
//   let callback = (entries, observer) => {
//     entries.forEach(entry => {
//       if(entry.isIntersecting){
//         const entryIndex = entry.target.dataset.index;
//         const targetIndex = entryIndex >= 0 ? entryIndex : 0;
//         const targetThumb = document.querySelector(`.thumbnails [data-index="${targetIndex}"]`);
//         clearTimeout(debouncer);
//         debouncer = setTimeout(() => {
//           const selectedThumb = document.querySelector('.thumbnails .selected');
//           selectedThumb && selectedThumb.classList.remove('selected');
//           targetThumb && targetThumb.classList.add('selected');
//           swiper.slideTo(entryIndex);
//         },250);
//       }
//     });
//   };

//   observer = new IntersectionObserver(callback, {threshold: 0.25});
//   let targets = document.querySelectorAll(observerTargetsClass);
//   Array.from(targets).forEach(target => {
//     observer.observe(target);
//   })
// }

// function setMarkersWidth(){
//   const setWidth = (thumbImg) => {
//     const thumbsWidth = thumbImg.clientWidth;
//     document.querySelectorAll('.thumbs-marker').forEach( tm => tm.style.width = `${thumbsWidth}px`);
//     return thumbImg;
//   }
//   const thumb = document.querySelector('.thumbnails .thumbnail-button img');
//   setWidth(thumb).addEventListener('load', function(event){
//     setWidth(event.target);
//   });
// }

// function setSelectedThumb(target){
//   const targetThumb = target.closest('.swiper-slide');
//   const index = targetThumb.dataset.index;
//   const targetSlide = document.querySelector(`.col-images .product-slide[data-index="${index}"]`);
//   //  if(targetSlide){
//     // scrollBehavior.scrollTo(targetSlide);
//   //  }
// }

// function initThumbnails() {
//   thumbCarousel = new Swiper(".thumbnails", {
//     init: false,
//     direction: "vertical",
//     containerModifierClass: "swiper-container-",
//     spaceBetween: 10,
//     watchSlidesProgress: true,
//     slidesPerView: 3,
//     grabCursor: true,
//     centerMode: true,
//     freeMode: {
//       enabled: true,
//       sticky: true,
//     },
//     preventClicksPropagation: false
//   }).on('transitionEnd', function(swiper){
//     handleThumbsMarkerVisibility(swiper);
//   }).on('click', function(swiper, event){
//     setSelectedThumb(event.target);
//   }).on('afterInit', function(swiper){
//     // syncThumbnailsWithScroll(swiper);  
//     handleThumbsMarkerVisibility(swiper);
//     setMarkersWidth();
//   }).init();
//   return thumbCarousel;
// }
 
// function initImageCarousel() {
//   mobileCarousel = new Swiper(".product-carousel-main", {
//     direction: "horizontal",
//     containerModifierClass: "swiper-container-",
//     watchSlidesProgress: true,
//     mousewheel: {
//       forceToAxis: true,
//     },
//     pagination: {
//       el: ".swiper-pagination",
//       clickable: true,
//     },
//     breakpoints: {
//       992: {
//         direction: 'vertical',
//         autoHeight: true
//       },
//     },
//   });
//   return mobileCarousel;
// }







function initImageCarouselPDP() {

  // IBT-3745
  // - Remove the image-carousel / swiper
  // - Keep the images in the normal document flow
  // - Set Thumbnails and product details to position sticky

  thumbCarousel = new Swiper(".thumbnails", {
    direction: "vertical",
    spaceBetween: 8,
    slidesPerView: 5,
    centerMode: true,
    freeMode: true,
    watchSlidesProgress: true
  })
  .on('transitionEnd', function(thumbCarousel){
    handleThumbsMarkerVisibility(thumbCarousel);
  })
  .on('afterInit', function(thumbCarousel){ 
    handleThumbsMarkerVisibility(thumbCarousel);
  });

  handleThumbsMarkerVisibility(thumbCarousel);

  thumbCarousel.slides.length < 1 && thumbCarousel.destroy(false, true);

  $('.wrapper-pdp').each(function() {
    const wrapper = $(this);
    const buttons = $('.thumbnails .thumbnail-button', this);
    const slides = $('.product-carousel-main.d-md-block .swiper-slide', this);

    buttons.on('click', function(e) {
      // console.debug('click', e);
      e.preventDefault();

      const index = buttons.index(this);
      // console.debug('index', index);

      const parent = $(this).parent();
      parent.siblings().removeClass('swiper-slide-thumb-active');
      parent.addClass('swiper-slide-thumb-active');

      wrapper.data('thubclick', index);

    });
  });

  $(window).on('scroll', () => {
    // console.debug('scroll');
    activateThumbs();
  });

  function activateThumbs() {
    // console.debug('activateThumbs');
    const top = $(window).scrollTop() + $('.mm-menu').height();

    $('.wrapper-pdp:visible').each(function() {
      const wrapper = $(this);
      const thumbs = $('.thumbnails .swiper-slide', this);
      const slides = $('.product-carousel-main.d-md-block .swiper-slide', this);
  
      let index = 0;
      slides.each((i, el) => {
        if ($(el).offset().top + $(el).outerHeight() > top) return false;
        index++;
      });
      // console.debug('index', index);

      const thumbclick = wrapper.data('thubclick');
      // console.debug('thumbclick', thumbclick);
      if (typeof thumbclick === 'number') {
        if (thumbclick !== index) return;
        wrapper.removeData('thubclick');
      }

      thumbs.each((i, el) => {
        $(el)[i == index ? 'addClass' : 'removeClass']('swiper-slide-thumb-active');
      });

      thumbCarousel && thumbCarousel.slideTo(index);
    });
  }

  $(window).on('resize', () => {
    // console.debug('resize');
    // repositionThumbs();
    createMobileSwiper();
  });

  /* IBT-3745 Right now there is a fixed height which looks weird on products with only 1 or 2 images
  function repositionThumbs() {
    // console.debug('repositionThumbs');

    $('.wrapper-pdp:visible').each(function() {
      const wrapper = $(this);
      const thumbs = $('.thumbs-carousel-col', this);
      const slide = $('.product-carousel-main.d-md-block .swiper-slide:first', this);
      thumbs.css('height', slide.outerHeight() + 'px');
    });
  }
  */

  function createMobileSwiper() {
    // console.debug('createMobileSwiper');
    $('.product-carousel-main').each(function() {
      // console.debug('this', this);
      new Swiper(this, {
        spaceBetween: 10,
        mousewheel: {
          forceToAxis: true
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        lazy: true,
        thumbs: {
          swiper: thumbCarousel
        },
        breakpoints: {
          992: {
            spaceBetween: 120,
            direction: 'vertical',
            slidesPerView: 1,
            centerMode: true,
            autoHeight: false,
            freeMode: {
              enabled: false,
              sticky: true,
            }
          },
        },
      });
    });
  }

  activateThumbs();
  // repositionThumbs();
  createMobileSwiper();
}





/**
 * Initiate slider
 * @returns {void}
 */
function productImageCarouselInit() {
  // initImageCarousel(); 
  // initThumbnails();


  initImageCarouselPDP();
}

function reInitCarousels(){
  // let targets = document.querySelectorAll(observerTargetsClass);
  // Array.from(targets).forEach(target => {
  //   observer.unobserve(target);
  // })
  thumbCarousel && thumbCarousel.destroy();

  productImageCarouselInit();
}

function init(){
  productImageCarouselInit();

  openFullscreenImage();
}

module.exports = {
  init: init,
  reInitCarousels: reInitCarousels
}